import Vue from 'vue'
import { notification } from 'ant-design-vue'
import { ApiPostLogRecordAdd } from '@/api/zonghoutai'

/**
 * 初始化全局错误处理
 * 包括 Vue 组件错误、JavaScript 运行时错误和 Promise 未捕获错误
 */
export function initErrorHandler () {
  // Vue 组件错误捕获
  Vue.config.errorHandler = (err, vm, info) => {
    console.error('Vue Error:', err)
    console.error('Component:', vm)
    console.error('Info:', info)
    // 在开发环境显示详细错误信息
    if (process.env.NODE_ENV === 'development') {
      notification.error({
        message: 'Vue 组件错误',
        description: err.message || '组件渲染时发生错误，请查看控制台获取详细信息',
        duration: 5
      })
    } else {
      // 生产环境显示友好提示
      ApiPostLogRecordAdd({
        title: 'Vue 组件错误',
        text: err.message || '组件渲染时发生错误，请查看控制台获取详细信息'
      })
    }
  }

  // JavaScript 运行时错误捕获
  window.addEventListener(
    'error',
    (event) => {
      console.error('JavaScript Error:', event.error)
      console.error('Error Message:', event.message)
      console.error('Error Source:', event.filename, ':', event.lineno, ':', event.colno)

      // 忽略资源加载错误（如图片、脚本等）
      if (event.target && event.target !== window) {
        return
      }

      // 在开发环境显示详细错误信息
      if (process.env.NODE_ENV === 'development') {
        notification.error({
          message: 'JavaScript 运行时错误',
          description: event.message || '发生运行时错误，请查看控制台获取详细信息',
          duration: 5
        })
      } else {
        // 生产环境显示友好提示
        ApiPostLogRecordAdd({
          title: 'JavaScript 运行时错误',
          text: event.message || '发生运行时错误，请查看控制台获取详细信息'
        })
      }
      // 阻止默认的错误处理
      event.preventDefault()
    },
    true
  )

  // Promise 未捕获错误捕获
  window.addEventListener('unhandledrejection', (event) => {
    console.error('Unhandled Promise Rejection:', event.reason)

    // 忽略某些已知的错误（如取消的请求）
    if (event.reason && event.reason.message && event.reason.message.includes('cancel')) {
      return
    }

    // 在开发环境显示详细错误信息
    if (process.env.NODE_ENV === 'development') {
      notification.error({
        message: 'Promise 未捕获错误',
        description: event.reason?.message || event.reason?.toString() || '异步操作发生错误，请查看控制台获取详细信息',
        duration: 5
      })
    } else {
      ApiPostLogRecordAdd({
        title: 'Promise 未捕获错误',
        text: event.reason?.message || event.reason?.toString() || '异步操作发生错误，请查看控制台获取详细信息'
      })
    }

    // 阻止默认的错误处理
    event.preventDefault()
  })
}
